export const ChannelConst = ({
    DigitalVideo: {
        id: 1,
        label: 'Digital Video'
    },
    LinearTV: {
        id: 2,
        label: 'Linear TV'
    },
    Social: {
        id: 3,
        label: 'Social'
    }
});